export default __webpack_public_path__ + "static/5_32-187a0dc208581177ed5f14c1d79f4494.png";